/**
 * Describes a contact (person or job-site) and means to contact them.
 */
export interface IContact {
  contactId?: number;
  contactCode?: number;
  name: string;
  countryAreaCode?: string;
  phone: string;
  extension?: string;
  email?: string;
}
